import React, { useEffect, Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { schTfcs, schCount, schAlloted, schApplns } from '../../actions/rank';

import {TFC_CENTER} from '../../Constant';
import moment from 'moment';

const TSchedule = ({ 
  history, 
  schTfcs,
  schCount,
  schAlloted,
  schApplns,
  auth: { user },
  rank: {count, alloted, candprofiles}
}) => {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []); 

  const [formData, setFormData] = useState({    
    tfcname: '1', schday: moment(new Date()).format('YYYY-MM-DD'),  slot: '1', ncand: '10', exyes: 'n', disyes: 'n'
  });


  const {
    tfcname, schday, slot, ncand, exyes, disyes
  } = formData;

  const onSubmit = async e => {
    e.preventDefault(); 
    const tobesent = {};     
    tobesent.tfcname = formData.tfcname;
    tobesent.schday = formData.schday;
    tobesent.slot = formData.slot;
    tobesent.ncand = formData.ncand;
    tobesent.exyes = formData.exyes;
    tobesent.disyes = formData.disyes;

    //console.log("on submit from incomplete");    
    //console.log(formData);
    await schTfcs(tobesent);
    console.log("completed schedule");
    
    //await schCount(tobesent);
    //console.log("completed count");
    
  };

  const onCount = async e => {
    e.preventDefault();
    const tobesent = {};     
    tobesent.tfcname = formData.tfcname;
    tobesent.schday = formData.schday;
    tobesent.slot = formData.slot;
    tobesent.ncand = formData.ncand;
    tobesent.exyes = formData.exyes;
    tobesent.disyes = formData.disyes;
    //console.log(formData);
    await schCount(tobesent);
    console.log("completed count");
    
    await schAlloted(tobesent);
    console.log("completed alloted count");
  };

  const onGetall= async e => {
    e.preventDefault();
    const tobesent = {};     
    tobesent.tfcname = formData.tfcname;
    tobesent.schday = formData.schday;
    tobesent.slot = formData.slot;
    //console.log(formData);
    await schApplns(tobesent);
    console.log("completed all applns");
  };

  const onChange = e => {
    setFormData({ ...formData, [e.target.name] : e.target.value });  
    //name: e.target.value to change name alone
    console.log(e.target.value);
  }



  return (
    <Fragment>      
      
      <div>
      <h1 className='text-danger my-1'> TFC  CV Scheduling </h1>
       
      <form className='form' > 
               
        <div className = "form-group container3">
            <small className="form-text">
                Select TFC
            </small>
            <select name="tfcname" value={tfcname} onChange = {(e) => onChange(e)} >
              {TFC_CENTER.map(e => <option key = {e.key} value = {e.key}> {e.label} </option>)}
          </select>
          </div>

          <div className="grid-2" style={{alignItems: "center", textAlign: "center"}}>

          <div className="form-group container3">   

          <small className="form-text">         
            <label> Date </label>             </small>
            
            <input type="date" name="schday" value={schday} onChange = {e => onChange(e)}/>
          </div>

          <div className="form-group container3">
            <small className="form-text">
                Select Slot
            </small>
                <select name="slot" value={slot} onChange={e => onChange(e)}>          
                    <option value="1"> 9 am to 10 am </option>
                    <option value="2"> 10 am to 11 am </option>
                    <option value="3"> 11 am to 12 pm </option>
                    <option value="4"> 12 pm to 1 pm </option>
                    
                    <option value="5"> 2 pm to 3 pm </option>
                    <option value="6"> 3 pm to 4 pm </option>
                    <option value="7"> 4 pm to 5 pm </option>
                </select>
          </div>

          <div className="but-center">  
          <input type="submit" className="btn btn-primary" value="Get Count" onClick= {e => onCount(e)} />  
          <input type="submit" className="btn btn-danger" value="Get Applns" onClick= {e => onGetall(e)} />  
          <Link className='btn' to='/dashboard'>
              Cancel
          </Link>

          </div>
</div>

<div className="grid-2" style={{fontSize: "12px"}}>

      <div className="profile-grid">
      {count && count[0] ? (
      <div>
        <h3 style={{textAlign: "center"}}> Unalloted </h3>
      {count.map((profile) => (
      <div className="grid-3">
        <div>Ex: {profile._id.ex} </div>
        <div>Dap: {profile._id.dap} </div>
        <div>Count: {profile.count} </div>
      </div> 
      ) ) }
      

      </div> )
  
      : null}
      </div>
      

      <div className="profile-grid">
      {alloted && alloted[0] ? (
      <div>
        <h3 style={{textAlign: "center"}}> Alloted </h3>
      {alloted.map((profile) => (
      <div className="grid-3">
        <div>Ex: {profile._id.allex} </div>
        <div>Dap: {profile._id.alldap} </div>
        <div>Alloted: {profile.count} </div>
      </div> 
      ) ) }
      </div> )
  
      : null}   

      </div>

</div>

<div className="profile-grid">
      {candprofiles && candprofiles.allapplns ? (
      <div>
        <h3 style={{textAlign: "center"}}> candidates list {candprofiles.allapplns.length} </h3>
        {candprofiles.allapplns.map((profile) => (
        <> {profile._aid}  </>
      ) ) }
      </div> )
  
      : null}   

      </div>

        <div className="grid-4">

        <div className="form-group container3">
            <small className="form-text">
                Include Ex-Serviceman
            </small>
                <select name="exyes" value={exyes} onChange={e => onChange(e)}>
                    <option value="y">Yes</option>
                    <option value="n">No</option>
                </select>
        </div>

        <div className="p-3 container3" style={{textAlign: "center", fontWeight: "bold"}}> (OR) </div>

        <div className="form-group container3">
            <small className="form-text">
                Include Disabled
            </small>
                <select name="disyes" value={disyes} onChange={e => onChange(e)}>
                    <option value="y">Yes</option>
                    <option value="n">No</option>
                </select>
        </div>

          
        <div className="form-group container3">   
            <small className="form-text">         
              <label> No.of.candidates </label>             
            </small>
            <input type="text" name="ncand" value={ncand} onChange = {e => onChange(e)}/>                                       
        </div>
        
                                
        </div> 
      
      </form>
           
       <div className="but-center">
      <input type="submit" className="btn btn-primary" value="Generate and Save" onClick= {e => onSubmit(e)} />                     
      </div>

  
      </div>

      
      
    </Fragment>
  );
};

TSchedule.propTypes = {
  schTfcs: PropTypes.func.isRequired,
  schCount: PropTypes.func.isRequired,
  schAlloted: PropTypes.func.isRequired,
  schApplns: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  rank: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  rank: state.rank
});

export default connect(
  mapStateToProps,
  { schTfcs, schCount, schAlloted, schApplns }
)(withRouter(TSchedule));
